module.exports = __webpack_public_path__ + "static/wordpress-76a14472e8135cc9046c770e85323df7.png";